import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FloatInput, FloatSelect, showToast } from "src/componentes";
import { NFeEventoCadastroDto } from "../NFe.Evento.Dto";
import yup from "src/validators/yup.Module";
import { yupResolver } from "@hookform/resolvers/yup";
import { NFeEventoIncluir } from "src/services/Fiscal.Service";
import { MapearErrosServidorCampo } from "src/hook/Functions";

interface Props {
  show: boolean;
  nfeId: number;
  onClose: (show: boolean) => void;
  onReload: () => void;
}

const NFeEventoModalCadastro = (props: Props) => {
  type FormType = yup.InferType<typeof NFeEventoCadastroSchema>;

  const NFeEventoCadastroSchema = yup.object().shape({
    tipoEvento: yup
      .number()
      .typeError("O tipo de evento é obrigatório.")
      .required("O tipo de evento é obrigatório."),
    descricao: yup
      .string()
      .transform((v) => (v ? v.trim() : v))
      .when("tipoEvento", {
        is: (tipoEvento: number) => tipoEvento === 110111,
        then: (schema) =>
          schema.required("A justificativa do cancelamento é obrigatória."),
      })
      .when("tipoEvento", {
        is: (tipoEvento: number) => tipoEvento === 110110,
        then: (schema) =>
          schema.required("A descrição da correção é obrigatória."),
      }),
  });

  const form = useForm<FormType>({
    resolver: yupResolver(NFeEventoCadastroSchema),
  });

  const onSubmit = async (data: FormType) => {
    const dto: NFeEventoCadastroDto = {
      nfeId: props.nfeId,
      tipoEvento: data.tipoEvento,
      cancelamento:
        data.tipoEvento === 110111
          ? { justificativaCancelamento: data.descricao }
          : null,
      correcao:
        data.tipoEvento === 110110
          ? { descricaoCorrecao: data.descricao }
          : null,
    };

    const response = await NFeEventoIncluir(dto);
    if (response.data.success) {
      props.onClose(false);
      showToast({
        message: "Evento incluído com sucesso",
        title: "Sucesso",
        variant: "Success",
      });
      props.onReload();
    } else {
      MapearErrosServidorCampo(response.data.notifications, form.setError);
      response.data.notifications.forEach((item) => {
        showToast({
          message: item.key + ": " + item.message,
          title: "Erro",
          variant: "Danger",
        });
      });
    }
  };

  const onCloseHandlder = () => {
    props.onClose(false);
  };

  return (
    <>
      <Modal show={props.show} centered>
        <Form noValidate onSubmit={form.handleSubmit(onSubmit)}>
          <Modal.Body>
            <Row>
              <Col xs={12}>
                <FloatSelect
                  label="Tipo de Evento"
                  options={[
                    { label: "Selecione" },
                    { value: "110111", label: "Cancelar" },
                    { value: "110110", label: "Carta de Correção" },
                  ]}
                  register={form.register("tipoEvento")}
                  errorsMessage={form.formState.errors.tipoEvento}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <FloatInput
                  label={
                    form.watch("tipoEvento") === 110111
                      ? "Justificativa do Cancelamento"
                      : form.watch("tipoEvento") === 110110
                      ? "Descrição da Correção"
                      : "Descrição"
                  }
                  inputMask="textarea"
                  maxLength={1000}
                  registerField={form.register("descricao")}
                  errorsMessage={form.formState.errors.descricao}
                />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-primary" type="submit">
              Confirmar
            </Button>
            <Button variant="outline-secondary" onClick={onCloseHandlder}>
              Sair
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};
export default NFeEventoModalCadastro;
